import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const HeaderWrapper = styled.header`
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-logo {
    border-radius: 50px;
    transition: box-shadow 0.1s;

    svg {
      width: 90px;
      height: auto;
      fill: ${mainColors.main_color};
      border-radius: inherit;

      &:hover {
        box-shadow: 0px 0px 10px 0px ${mainColors.text_color};
      }

      @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
        width: 66px;
        height: 62px;
      }
      @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
        width: 50px;
        height: 44px;
      }
    }
  }

  .right-side-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-navigation-buttons-container {
    display: flex;
    justify-content: end;

    .sign-up-btn button {
      background: transparent;

      &:hover {
        box-shadow: 0px 0px 10px 0px ${mainColors.main_color};
      }
    }

    .link-btn {
      display: inline-block;
      cursor: auto;

      button {
        @media only screen and (max-width: ${sizeStandards.screen.XS}px) {
          font-size: 12px;
        }
      }
    }
  }

  .profile-dropdown .dropdown-menu-container {
    left: ${({ $language }) => ($language === 'hy' ? '-45px' : '-40px')};
    top: -30px;

    @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
      left: ${({ $language }) => ($language === 'hy' ? '-50px' : '-43px')};
      top: -28px;
    }

    .dropdown-menu {
      max-width: ${({ $language }) => ($language === 'hy' ? '130px' : 'unset')};
      white-space: ${({ $language }) => ($language === 'hy' ? 'pre-wrap' : 'no-wrap')};
    }

    .menu-item {
      .edit-btn,
      .reservations-btn {
        display: block;
      }

      .logout-btn,
      .reservations-btn,
      .edit-btn {
        background: none;
        border: none;
        margin: 0;
        font-family: 'Segoe UI';

        p {
          padding: 0;
          margin: 0;

          @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
            font-size: ${sizeStandards.font.XS}px !important;
          }
        }
      }
    }
  }

  .language-flag-icon-btn {
    display: inline-flex;
    transition: transform 0.4s ease-in-out;

    svg {
      width: 30px;
      height: 30px;
      margin: 0;
    }

    &.spin {
      transform: rotate(360deg);
    }
  }
`;

export default HeaderWrapper;
